import { h } from 'preact';
export const Repeat = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "17 1 21 5 17 9" }),
        h("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" }),
        h("polyline", { points: "7 23 3 19 7 15" }),
        h("path", { d: "M21 13v2a4 4 0 0 1-4 4H3" })));
};
//# sourceMappingURL=repeat.js.map